import React, { useState, useEffect } from 'react';
import { fehlertext } from '../lib/fehlertext';
import { timesheetsAPI } from '../lib/api';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../components/ui/dialog';
import { Button } from '../components/ui/button';
import { History, Loader2, RotateCcw } from 'lucide-react';
import { toast } from 'sonner';

export function VersionHistoryDialog({ open, onClose, timesheetId, timesheetName, isSubmitted, onRestored }) {
  var [history, setHistory] = useState([]);
  var [loading, setLoading] = useState(false);
  var [restoring, setRestoring] = useState(null);

  useEffect(function() {
    if (open && timesheetId) {
      setLoading(true);
      timesheetsAPI.getHistory(timesheetId).then(function(res) {
        setHistory(res.data.history || []);
      }).catch(function() { setHistory([]); }).finally(function() { setLoading(false); });
    }
  }, [open, timesheetId]);

  function restore(index) {
    setRestoring(index);
    timesheetsAPI.restoreVersion(timesheetId, index).then(function() {
      toast.success('Version wiederhergestellt');
      if (onRestored) onRestored();
      onClose();
    }).catch(function(err) {
      var msg = fehlertext(err, 'Fehler');
      toast.error(msg);
    }).finally(function() { setRestoring(null); });
  }

  var items = [];
  for (var i = 0; i < history.length; i++) {
    var h = history[i];
    var ts = h.saved_at ? new Date(h.saved_at).toLocaleString('de-DE') : '—';
    var entryCount = (h.entries || []).length;
    var workedCount = 0;
    // Bewusst nur Anwesenheitstage: hier werden TAGE gezählt, keine Stunden.
    // Kind-krank-Tage bleiben absichtlich draußen (das Kind war nicht in der Schule).
    for (var j = 0; j < (h.entries || []).length; j++) {
      if (h.entries[j].status === 'gearbeitet' && (h.entries[j].hours || 0) > 0) workedCount++;
    }
    (function(idx, timestamp, ec, wc) {
      items.push(
        <div key={idx} className="flex items-center justify-between p-3 border border-slate-200 rounded-lg">
          <div>
            <p className="text-sm font-medium text-slate-900">Version {idx + 1}</p>
            <p className="text-xs text-slate-500">{timestamp} · {ec} Einträge, {wc} Arbeitstage</p>
          </div>
          <Button size="sm" variant="outline" onClick={function() { restore(idx); }}
            disabled={isSubmitted || restoring !== null}
            data-testid={'restore-version-' + idx}>
            {restoring === idx ? <Loader2 className="h-4 w-4 mr-1 animate-spin" /> : <RotateCcw className="h-4 w-4 mr-1" />}
            Wiederherstellen
          </Button>
        </div>
      );
    })(i, ts, entryCount, workedCount);
  }

  return (
    <Dialog open={open} onOpenChange={function(v) { if (!v) onClose(); }}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><History className="h-5 w-5" /> Versionen{timesheetName ? ' – ' + timesheetName : ''}</DialogTitle>
        </DialogHeader>
        {loading ? (
          <div className="flex items-center gap-2 py-4 text-slate-500"><Loader2 className="h-4 w-4 animate-spin" /> Laden...</div>
        ) : history.length === 0 ? (
          <p className="text-sm text-slate-500 py-4">Keine früheren Versionen vorhanden.</p>
        ) : (
          <div className="space-y-2">
            {isSubmitted && <p className="text-xs text-amber-600">Stundenzettel ist eingereicht — bitte zuerst wieder öffnen.</p>}
            {items}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
